<template>
<div class="form">
  <v-card  style="margin-top: 250px">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <h1 align="center" style="text-decoration: underline overline;">Butir - Butir Pengenalan (JR2)</h1>

          <v-text-field
            outlined 
            dense
            rounded
            v-model="HID"
            label="HID"
            width="20px"
            disabled
          ></v-text-field>


        <!-- DATATABLE  -->
        <v-card  class="mb-5">
            <v-card-title>
                Senarai Pengisian
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataJR2"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
              :hide-default-footer="true"
            ></v-data-table>
          </v-card> 
</v-card> 



<v-card>

  

  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      
    >
        <v-row>
          <v-col>
          Nama Responden
          <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>Ruangan ini adalah untuk nama individu/ responden yang ditemu ramah.</span>
          </v-tooltip>

            <v-text-field
                v-model="Nama"
                outlined
                dense
            ></v-text-field>
          </v-col>
        </v-row>

         <!-- <v-row>
          <v-col class="black--text" >
            Kad Pengenalan 
            <v-text-field
                v-model="NOIC"
                outlined
                dense
                required
            ></v-text-field>
          </v-col>
        </v-row> -->


        <v-row>
          <v-col>
          Alamat
            <v-text-field
                v-model="Alamat"
                outlined
                dense
                disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            Email
            <v-text-field
              outlined
              dense
              v-model="Email"
              :rules="[rules.emel]"
            ></v-text-field>
          </v-col>
        </v-row>
        
         <v-row>
          <v-col>
            Kumpulan Etnik Responden
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>Ruangan ini adalah untuk kumpulan etnik individu/ responden yang ditemu ramah.</span>
              </v-tooltip>
            <v-autocomplete
            :items="kumpulanEtnik"
            :item-text="item => item.kodEtnik +' - '+ item.namaEtnik"
            return-object
            outlined
            dense
            v-model="Etnik"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
          Bandar/Mukim
            <v-text-field
                v-model="Bandar"
                outlined
                dense
            ></v-text-field>
          </v-col>
        </v-row>
    </v-form>
  </v-card-text>

    <v-card style="background:#DBDBDB;">
        <v-card-title>
          Untuk Kegunaan Pejabat
          <span style="color:red;font-weight:bold;font-size: small;"> Medan yang bertanda * wajib diisi</span>
        </v-card-title>
       <v-card-text>
            <v-form
              ref="form2"
              v-model="valid"
              lazy-validation
            >
                <v-row>
                  <v-col>
                    Kad Pengenalan Ketua Isi Rumah<span style="color:red;font-weight:bold;font-size: small;"> * </span>
                    <v-text-field
                        v-model="NOIC"
                        outlined
                        dense   
                        min="1"
                        maxlength="12"
                        :rules="[rules.noicKIR]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                 <v-row>
                  <v-col>
                    Jumlah Ahli Isi Rumah <strong>[JAIS]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                    <v-text-field
                        v-model="JAIS"
                        outlined
                        dense
                        min="1"
                        maxlength="2"
                        :rules="[rules.jais]"
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    Jumlah Penerima Pendapatan <strong>[JPP]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                    <v-text-field
                        v-model="JPP"
                        outlined
                        dense
                        min="1"
                        maxlength="2"
                        :rules="[rules.jpp]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                 <v-row>
                  
                  <v-col class="black--text">
                    Kewarganegaraan <strong>[KWKIRB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                      <v-autocomplete
                      :items="kewarganegaraan"
                      :item-text="item => item.id +' - '+ item.desc"
                      label="Sila pilih Kewarganegaraan.."
                      return-object
                      outlined
                      dense
                      v-model="KWKIRB"
                      :rules="[rules.kWargaKIRB]"
                      ></v-autocomplete>
                   </v-col>


                  <v-col>
                    Kumpulan Etnik Ketua Isi Rumah <strong>[KKIRB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                    <v-autocomplete
                    :items="kumpulanEtnik"
                    :item-text="item => item.kodEtnik +' - '+ item.namaEtnik"
                    label="Sila pilih Etnik.."
                    return-object
                    outlined
                    dense
                    v-model="KKIRB"
                    :rules="[rules.kEtnikKIRB]"
                    ></v-autocomplete>
                  </v-col>

                  
                </v-row>

                <v-row>
                  <v-col>
                  Apakah jenis pekerjaan utama ketua isi rumah? <strong>[PKKIRB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                  <v-autocomplete
                      :items="masco"
                      :item-text="item => item.kod +' - '+ item.keterangan"
                      return-object
                      label="Sila pilih.."
                      outlined
                      dense
                      v-model="PKKIRB"
                     :rules="[rules.pekerjaanKIRB]"
                  ></v-autocomplete>
                  </v-col>
                </v-row>

                <!-- s25 -->
                <v-row>
                  <v-col>
                  Apakah aktiviti/hasil pengeluaran utama (industri) ketua isi rumah? <strong>[PNKIRB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                  <v-autocomplete
                      :items='msic'
                      :item-text="item => item.kod +' - '+ item.keterangan"
                      return-object
                      outlined
                      label="Sila pilih.."
                      dense
                      :rules="[rules.industriKIRB]"
                      v-model="PNKIRB"
                  ></v-autocomplete>
                  </v-col>
                </v-row>

            </v-form>
          </v-card-text>

      
    </v-card>

    <v-card-actions> 
      <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click='simpan()'
              :disabled="butangSimpan"
          >
            Simpan/Kemaskini
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="goTo()"
          >
            Seterusnya
          </v-btn>
    </v-card-actions>
</v-card>


 
<!-- DIalog -->
<!-- <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{message}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
</v-dialog> -->

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>
</div>
</template>
<script>
import axios from '../../plugins/axios'

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();

import pubServices from '@/services/publicServices'
const publicServices = new pubServices();



export default {
  
    async beforeMount(){

        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;
        //this.Nama = dataHID.Nama;
        this.Alamat = dataHID.Alamat + ' ' + dataHID.Alamat1 + ' ' + dataHID.Alamat2 + ' ' + dataHID.Alamat3;

        this.kumpulanEtnik = await lookupFieldServices.getKumpulanEtnik();
        this.kewarganegaraan = lookupFieldServices.getKewarganegaraan();
        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;

        this.getData();//dapatkan data based on HID
    },
    data: () => ({
        updateButton: true,
        saveButton: false,
        butangSimpan: true,
        dialog: false,
        kemaskiniDialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        kumpulanEtnik:'',
        kewarganegaraan:[],
        masco:[],
        msic:[],
        /////////////////////data declaration//////////////////////////
        HID: '',
        NOAIR:'',
        KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:1,
        Bandar:'',
        Nama:'',
        Etnik:'',
        Email:'',
        Alamat:'',
        dataJR2:[],
        NOIC:'',
        JAIS:'',
        JPP:'',
        KWKIRB:'',
        KKIRB:'',
        PKKIRB:'',
        PNKIRB:'',
        headers: [
          // {
          //   text: 'HID',
          //   align: 'start',
          //   sortable: false,
          //   value: 'HID',
          // },
          { text: 'Nama', value: 'Nama' },
          { text: 'NOIC', value: 'NOIC' },
          { text: 'Bandar', value: 'Bandar' },
          { text: 'Etnik Responden', value: 'KER' },
          { text: 'Email', value: 'Email' },
          { text: 'JPP', value: 'JPP' },
          { text: 'JAIS', value: 'JAIS' },
          { text: 'KWKIRB', value: 'KWKIRB' },
          { text: 'Etnik KIR', value: 'KKIRB' },
          { text: 'PKKIRB', value: 'PKKIRB' },
          { text: 'PNKIRB', value: 'PNKIRB' },

        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'JR2',
          disabled: true,
          href: 'JR2',
        },
      ],
      valid: true,
      name: '',
      rules: {
      required: (v) => !!v || "field is required",
        Slength: (value) => {
          return (value && value.length == 1) || "must be 1 digit";
        },
        NOTKlength: (value) => {
          return (value && value.length == 4) || "must be 4 digit";
        },
        NOIRlength: (value) => {
          return (value && value.length == 2) || "must be 2 digit";
        },
        Rlength: (value) => {
          return (value && value.length == 1) || "must be 1 digit";
        },
        poskodLength: (value) => {
          return (value && value.length == 5) || "must be 5 digit";
        },
        notkLength: (value) => {
          return (value && value.length == 1) || "must be 1 digit";
        },
        emel: (value) => {
          return /.+@.+\..+/.test(value) || "E-mail haruslah yang betul";
        },
         noicKIR: (v) => !!v || "No Kad Pengenalan KIR adalah diperlukan",
         jais: (v) => !!v || "Jumlah Ahli Isi Rumah Biasa adalah diperlukan",
         jpp: (v) => !!v || "Jumlah Penerima Pendapatan adalah diperlukan",
         kWargaKIRB: (v) => !!v || "Kewarganegaraan Ketua Isi Rumah Biasa adalah diperlukan",
         kEtnikKIRB: (v) => !!v || "Kumpulan Etnik Ketua Isi Rumah Biasa adalah diperlukan",
         pekerjaanKIRB: (v) => !!v || "Jenis Pekerjaan Ketua Isi Rumah Biasa adalah diperlukan",
         industriKIRB: (v) => !!v || "Aktiviti/Hasil Pengeluaran Utama (Industri) Ketua Isi Rumah Biasa adalah diperlukan",

      },
      select: null,
      checkbox: false,
    }),
    methods: {

      // checkForm: checknoicKIR(e){
      //   this.error =[];
      //   if(!this.NOIC){
      //     this.error.push("No Kad Pengenalan KIR adalah diperlukan")
      //   }
      // }
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
        this.$refs.form2.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      async simpan (){
        // if (this.$refs.form.validate()){
        //     this.dialog =  true;
        //     setTimeout(() => (this.dialog = false), 2000)
          // var checknoicKIR = this.NOIC.toString().length;
          // var checkJAIS = this.JAIS.toString().length;
          // var checkTOTJPP = this.JPP.toString().length;
          // var checkKWKIRB = this.KWKIRB.toString().length;
          // var checkKKIRB = this.KKIRB.toString().length;
          // var checkPKKIRB = this.PKKIRB.toString().length;
          // var checkPNKIRB = this.PNKIRB.toString().length;
          
          // if(checknoicKIR < 11){
          //   this.NOIC = "0"+this.NOIC;
          // }
          // if(checkJAIS < 2){
          //   this.JAIS = "0"+this.JAIS;
          // }
          // if(checkTOTJPP < 2){
          //   this.JPP = "0"+this.JPP;
          // }
          // if(checkKWKIRB < 1){
          //   this.KWKIRB = "0"+this.KWKIRB;
          // }
          // if(checkKKIRB < 6){
          //   this.KKIRB = "0"+this.KKIRB;
          // }
          // if(checkPKKIRB < 6){
          //   this.PKKIRB = "0"+this.PKKIRB;
          // }
          // if(checkPNKIRB < 5){
          //   this.PNKIRB = "0"+this.PNKIRB;
          // }
            try {

                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR/JR2`, {
             
                  HID : this.HID,
                  NOAIR : this.NOAIR,
                  BNO : this.BNO,
                  Ps : this.Ps,
                  S : this.S,
                  NG : this.NG,
                  DP : this.DP,
                  DB : this.DB,
                  BP : this.BP,
                  ST : this.ST,
                  NOTK : this.NOTK,
                  NOIR : this.NOIR,
                  Bulan : this.Bulan,
                  Tahun : this.Tahun,
                  Bandar : this.Bandar,
                  Nama : this.Nama,
                  NOIC : this.NOIC,
                  KER : this.Etnik.kodEtnik,
                  Alamat : this.Alamat,
                  Email: this.Email,
                  JAIS: this.JAIS,
                  JPP: this.JPP,
                  KWKIRB: this.KWKIRB.id,
                  KKIRB: this.KKIRB.kodEtnik,
                  PKKIRB: this.PKKIRB.kod,
                  PNKIRB: this.PNKIRB.kod
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Disimpan!';
                this.reset();
                this.getData();
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        //}
      },
 
      async getData(){
        
        try {
            const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR/papardatajr2`, {
              hidjr2: this.HID
            })
            var dataz = res.data.data;
            this.dataJR2 = [dataz];
            //console.log(this.dataJR2)
            this.Nama =  this.dataJR2[0].Nama;
            this.Alamat =  this.dataJR2[0].Alamat +' '+this.dataJR2[0].Alamat1+' '+this.dataJR2[0].Alamat2+' '+this.dataJR2[0].Alamat3 ;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      handleClick(row) {
        this.kemaskiniDialog = true;
        setTimeout(() => (this.kemaskiniDialog = false), 1000);
        this.Nama =  row.Nama;
        this.NOIC =  row.NOIC;
        this.Email = row.Email;
        this.JPP = row.JPP;
        this.JAIS = row.JAIS;
        this.Bandar = row.Bandar;
        this.KWKIRB = this.kewarganegaraan[row.KWKIRB - 1];

        for(var i=0;i<this.kumpulanEtnik.length;i++){
          if(row.KKIRB == this.kumpulanEtnik[i].kodEtnik){
            //console.log(this.Etnik + " - "+this.kumpulanEtnik[i] )
            this.KKIRB = this.kumpulanEtnik[i];
          }
          if(row.KER == this.kumpulanEtnik[i].kodEtnik){
            //console.log(this.Etnik + " - "+this.kumpulanEtnik[i] )
            this.Etnik = this.kumpulanEtnik[i];
          }
        }

        for(var a=0;a<this.masco.length;a++){
          if(row.PKKIRB == this.masco[a].kod){
            this.PKKIRB = this.masco[a];
          }
        }

        for(var b=0;i<this.msic.length;b++){
          if(row.PNKIRB == this.msic[b].kod){
            this.PNKIRB = this.msic[b];
          }
        }
        

      },
      goTo(){
          this.$router.push({name: "JRC"});
      }
    },
    watch:{

      PNKIRB(val){
        if(this.PNKIRB > 0){  
          if(this.PKKIRB > 0){
            if(this.KKIRB > 0){
              if(this.KWKIRB > 0){
                if(this.JPP > 1){
                  if(this.JAIS > 1){
                    if(this.NOIC > 1){
                      this.butangSimpan = true;
                    } 
                  } 
                } 
              } 
            } 
          }     
            }else{
              this.butangSimpan = false;
      }      
      },
      
    }

}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>